import React, { useEffect, useState,useRef  } from "react"
import MetaTags from 'react-meta-tags';
import Select from "react-select";
import moment from "moment";
import ReactBSAlert from "react-bootstrap-sweetalert";
import {Modal} from "reactstrap";
import {ModalBody,ModalHeader} from "reactstrap";
import {
    Col,
    Row,
    Card,
    CardBody,
    Button,
    Container,
    ButtonGroup,
    UncontrolledTooltip,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    ButtonDropdown,
    CardTitle,
    CardHeader,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link } from "react-router-dom";
const { SearchBar } = Search;
import { connect } from "react-redux";
import { Search } from "react-bootstrap-table2-toolkit";
//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import paginationFactory from 'react-bootstrap-table2-paginator';
//import AddUserComponent from "./AddUserComponent";
import { apiEndpoint } from "helpers/url_helper";

import jwt from "jsonwebtoken";

const btnstylesObj = {
  "margin-top": '6rem',
};
const bsAlertStyle={
    "zIndex":10000,
    
}
const checkName = (name) => {
    const validRegExp = new RegExp(
      '^[A-Za-z]+$'
    );
    if(validRegExp.test(name) && name.length >= 3 && name.length <= 16){
      return true;
    }
    else{
      return false;
    }
  }
const UserRoles = (props) => {


    const [Userroleitems, setUserroleItems] = useState([]);
    const [SelectedUserroleitem, setSelectedUserroleItem] = useState([]);
    const [selectedUserroleVal, setUserroleSelected] = useState();
    const [editviolationlogs, seteditviolationlogs] = useState(false);
    const [deleteviolationlogs, setDeleteViolationLogs] = useState(false);
    const [vehiclecount, setvehiclecount] = useState(false);
    const [registerdevice, setregisterdevice] = useState(false);
    const [registervehicle, setregistervehicle] = useState(false);
    const [smtp, setsmtp] = useState(false);
    const [challan, setchallan] = useState(false);
    const [usermanagement, setusermanagement] = useState(false);
    const [rolemanagement, setrolemanagement] = useState(false);
    const [adduser, setadduser] = useState(false);
    const [editdeleteuser, seteditdeleteuser] = useState(false);
    const [addrole, setaddrole] = useState(false);
    const [editdeleterole, seteditdeleterole] = useState(false);
    const [changepassword, setchangepassword] = useState(false);
    const [alertmsg, setAlert] = useState([]);
    const [alertModal, setAlertModal] = useState([]);
    const [basic, setbasic] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [addroleaccess, setaddroleaccess] = useState();
    const [editdeleteroleaccess, seteditdeleteroleaccess] = useState();


    useEffect(() => {

      const decodedToken = jwt.decode(sessionStorage.getItem("Clear_AuthUser"));
      var UserPermissions=JSON.parse(decodedToken.userRolePermissions);
      // var UserPermissions=JSON.parse(sessionStorage.getItem("UserRolePermissions"));
      setaddroleaccess(UserPermissions.AddRole)
      seteditdeleteroleaccess(UserPermissions.EditDeleteRole)
        
      // UserValidated
      const url = apiEndpoint+'/GetUserRoles';
    fetch(url,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "strToken": sessionStorage.getItem("Clear_AuthUser")
        
      })
   
    })
  .then(res => res.json())
  .then(
    (result) => {
      if (result != undefined) {
        //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
        if (result.UserRoleList != undefined) {
          setUserroleItems(JSON.parse(result.UserRoleList));
          var UserRoleList = JSON.parse(result.UserRoleList);
          if(UserRoleList[0]!=null){
            setSelectedUserroleItem(UserRoleList[0]);
            setUserroleSelected(UserRoleList[0].value);
            }
        }
      }
      },

      (error) => {
          console.log(error);
          // /setError(error);
      }
  )
}, [])


    useEffect(() => {
        // UserValidated
        fetch(apiEndpoint+"/GetLogCampusList",
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              "strToken": sessionStorage.getItem("Clear_AuthUser")
              
            })
          })   
            .then(res => res.json())
            .then(
                (result) => {
                    if(result!=undefined){
                      //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                    }
                },
                (error) => {
                }
            )
    }, [])

    const setModalIsOpenToTrue =()=>{
        setModalIsOpen(true)
    }
    const setModalIsOpenToFalse =()=>{
        setModalIsOpen(false)
    }
    const toggle = () => {
        setModalIsOpen(!modalIsOpen)    
      }
    
    
    // User Role Change Event
    const changeUserroleSelectHandler = (event) => {
        setSelectedUserroleItem(event);
        setUserroleSelected(event.value);
        console.log(event.value)
      };
    useEffect(() => {
      console.log(selectedUserroleVal)
      if(selectedUserroleVal!=undefined){
        const getData = async () => {
          // user validation not required
      fetch(apiEndpoint+"/GetSelectedRolePermissions",
      {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          // 'Access,-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({
          "intUserRoleID": selectedUserroleVal,
          
        })
      })
      .then(res => res.json())
      .then(
          (result) => {
            console.log(result)
          if (result != undefined) {
            
            console.log(result.UserRolePermissions.EditViolations)
            seteditviolationlogs(result.UserRolePermissions.EditViolations)
            setvehiclecount(result.UserRolePermissions.VehicleCount)
            setregisterdevice(result.UserRolePermissions.RegisterDevice)
            setregistervehicle(result.UserRolePermissions.RegisterVehicle)
            setsmtp(result.UserRolePermissions.SMTP)
            setchallan(result.UserRolePermissions.Challan)
            setusermanagement(result.UserRolePermissions.UserManagement)
            setrolemanagement(result.UserRolePermissions.RoleManagement)
            setadduser(result.UserRolePermissions.AddUser)
            seteditdeleteuser(result.UserRolePermissions.EditDeleteUser)
            setaddrole(result.UserRolePermissions.AddRole)
            seteditdeleterole(result.UserRolePermissions.EditDeleteRole)
            setchangepassword(result.UserRolePermissions.ChangePassword)
            setDeleteViolationLogs(result.UserRolePermissions.DeleteViolations)
            

          }
        },
          (error) => {
              //console.log(error);
           
          }
      )}
        
        getData()
      }
    },
       
    [selectedUserroleVal])


    const SaveRolePermissions = () => {
        // useEffect(() => {
          debugger;
       // UserValidated
       fetch(apiEndpoint+"/SaveRolePermissions",
           {
               method: 'POST',
               headers: {
                   'Content-Type': 'application/json'
               },
               body: JSON.stringify({
                   "UserRoleID": selectedUserroleVal,
                   "IsRoleDeleted": false,
                   "EditViolations": editviolationlogs,
                   "VehicleCount": vehiclecount,
                   "RegisterDevice": registerdevice,
                   "RegisterVehicle": registervehicle,
                   "SMTP": smtp,
                   "Challan": challan,
                   "UserManagement": usermanagement,
                   "RoleManagement": rolemanagement,
                   "AddUser": adduser,
                   "AddRole": addrole,
                   "EditDeleteUser": editdeleteuser,
                   "EditDeleteRole": editdeleterole,
                   "ChangePassword": changepassword,
                   "DeleteViolations": deleteviolationlogs,
                   "Token": sessionStorage.getItem("Clear_AuthUser")       
               })
           })
           .then(res => res.json())
           .then(
               (result) => {
                   if(result!=undefined)
                   {
                    console.log(result.RowsAffected)
                   if(result.RowsAffected > 0)
                   {
                    console.log(result)
                    setAlert (
                        <ReactBSAlert
                          success
                        //   style={bsAlertStyle}
                          title="Saved changes successfully!"
                        onConfirm={() => setAlert(null)}
                        confirmBtnBsStyle="info"
                        >                  
                        </ReactBSAlert>
                      )
                      //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                      if(result.UserRolePermissions != undefined)
                      {
                        debugger;
                      //sessionStorage.setItem("UserRolePermissions",JSON.stringify(result.UserRolePermissions))
                      window.location.reload(false);
                      }
                   }
                   else{
                    setAlert (
                        <ReactBSAlert
                          warning
                        //   style={bsAlertStyle}
                          title="Something went wrong!"
                        onConfirm={() => setAlert(null)}
                          confirmBtnBsStyle="warning"
                        >
                     Unable to save changes..
                        </ReactBSAlert>
                      )
                   }
                   }
               },
               (error) => {
              
               }
           )
  
   }
   const DeleteRole = () => {
    setAlert (
        <ReactBSAlert
          warning
          onCancel={() => setAlert(null)}
          title="Do you want to delete this role?"
          onConfirm={() => funDelete()}
          confirmBtnBsStyle="warning"
          cancelBtnText="cancel"
          cancelBtnBsStyle="info"
        >                  
        </ReactBSAlert>
      )

      const funDelete=()=>{
        setAlert(null);
        // UserValidated
       fetch(apiEndpoint+"/DeleteUserRole",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "intUserRoleID": selectedUserroleVal,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
      })
      .then(res => res.json())
      .then(
        (result) => {
            if(result!=undefined)
            {
             console.log(result.RowsAffected)
            if(result.RowsAffected > 0)
            {
             setAlert (
                 <ReactBSAlert
                   success
                 //   style={bsAlertStyle}
                   title="Role deleted successfully!"
                 onConfirm={() => setAlert(null)}
                 confirmBtnBsStyle="info"
                 >                  
                 </ReactBSAlert>
               )

               // UserValidated
               const url = apiEndpoint+'/GetUserRoles';
               fetch(url,
               {
                
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    "strToken": sessionStorage.getItem("Clear_AuthUser")
                    
                  })              
               })
  .then(res => res.json())
  .then(
    (result) => {
      if (result != undefined) {
        //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
        if (result.UserRoleList != undefined) {
          setUserroleItems(JSON.parse(result.UserRoleList));
          var UserRoleList = JSON.parse(result.UserRoleList);
          if(UserRoleList[0]!=null){
          setSelectedUserroleItem(UserRoleList[0]);
          setUserroleSelected(UserRoleList[0].value);
          }
        }
      }
      },

      (error) => {
          console.log(error);
      }
  )
            }
            else{
             setAlert (
                 <ReactBSAlert
                   warning
                 //   style={bsAlertStyle}
                   title="Something went wrong!"
                 onConfirm={() => setAlert(null)}
                   confirmBtnBsStyle="warning"
                 >
              Unable to delete this role..
                 </ReactBSAlert>
               )
            }
            }
          }
        
        
      )
        }
  }
  const AddNewRole=()=>{
var roleName=document.getElementById("roleName").value;
if(checkName(roleName)){
  // UserValidated
fetch(apiEndpoint+"/AddNewUserRole",
{
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
        "UserRoleName": roleName,
        "strToken": sessionStorage.getItem("Clear_AuthUser")
    })
})
.then(res => res.json())
.then(
    (result) => {
        if(result!=undefined)
        {
            console.log(result.RowsAffected)
            if(result.RowsAffected > 0)
            {
                setModalIsOpen(false)
                setbasic(true);      
                // UserValidated     
                const url = apiEndpoint+'/GetUserRoles';
                fetch(url,
                
                  {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      "strToken": sessionStorage.getItem("Clear_AuthUser")
                      
                    })
                  })   
               
             
             .then(res => res.json())
             .then(
               (result) => {
                 if (result != undefined) {
                  //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                   if (result.UserRoleList != undefined) {
                     setUserroleItems(JSON.parse(result.UserRoleList));
                     var UserRoleList = JSON.parse(result.UserRoleList);
                     if(UserRoleList[0]!=null){
                     setSelectedUserroleItem(UserRoleList[0]);
                     setUserroleSelected(UserRoleList[0].value);
                     }
                   }
                 }
                 },
           
                 (error) => {
                     console.log(error);
                 }
             )
             setAlertModal(null)
            }
            else{
                setAlertModal (
                 <ReactBSAlert
                   warning
                 //   style={bsAlertStyle}
                   title="Something went wrong!"
                 onConfirm={() => setAlertModal(null)}
                   confirmBtnBsStyle="warning"
                 >
              Unable to add user role..
                 </ReactBSAlert>
               )
            }
        }
    },
    (error) => {
    }
)
}

  }
    const breadcrumbItems = [
    ]

  
 
    useEffect(() => {
        props.setBreadcrumbItems('User Roles', breadcrumbItems)
       
    })

    return (
       
        <React.Fragment>

            <MetaTags>
                <title>Indus | User Roles</title>
            </MetaTags>
          <br></br>
            <Row><h5 className="mt-1" > Select Role  </h5>
                <Col md={6}>
                {alertmsg }
                    {alertModal}         
                <Select value={SelectedUserroleitem} options={Userroleitems} onChange={changeUserroleSelectHandler}></Select>
                </Col>
                {addroleaccess &&
                   <Col md={6} style={{float:"right"}}>                      
                   <Button type="button" onClick={setModalIsOpenToTrue} color="primary" className="waves-effect waves-light">Add New Role</Button>{" "}
                   </Col>
}
                </Row>
                <br></br>
                <Row> 
                   </Row>
                   <br></br>
                   {editdeleteroleaccess &&
                   <Row>
                    <h5>User Role Permissions</h5>
                   
                        <Row>
                        <Col md={3}> <Card
                        style={{height:"91%"}}>
                      <CardBody>
                      <h5> Violations and Vehicle Count</h5>  
                      <br></br>
                                 
                      <Col md={12} style={{display:"inline-block"}}>
                    <div style={{display:"inline-block"}}
                        className="form-check form-switch form-switch-lg mb-3" >
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="customSwitchsizelg"
                            checked={editviolationlogs}
                            onChange={(event) => seteditviolationlogs(event.target.checked)}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="customSwitchsizelg"
                        >
                           <h6>Edit Violation Logs</h6> 
                        </label>
                    </div>
                </Col>

                <Col md={12} style={{display:"inline-block"}}>
                    <div style={{display:"inline-block"}}
                        className="form-check form-switch form-switch-lg mb-3" >
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="customSwitchsizelg"
                            checked={deleteviolationlogs}
                            onChange={(event) => setDeleteViolationLogs(event.target.checked)}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="customSwitchsizelg"
                        >
                           <h6>Delete Violation Logs</h6> 
                        </label>
                    </div>
                </Col>
               
                <Col md={12} style={{display:"inline-block"}}>
                    <div style={{display:"inline-block"}}
                        className="form-check form-switch form-switch-lg mb-3" >
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="customSwitchsizelg"
                            checked={vehiclecount}
                            onChange={(event) => setvehiclecount(event.target.checked)}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="customSwitchsizelg"
                        >
                           <h6> Vehicle Count</h6> 
                        </label>
                    </div>
                </Col>         
                   
                    </CardBody></Card>
                        </Col>
                        <Col md={3}> <Card>
                      <CardBody>
                      <h5> Settings</h5>  
                      <br></br>
                                 
                   
              
                     
                      <Col md={12} style={{display:"inline-block"}}>
                        
                    <div style={{display:"inline-block"}}
                        className="form-check form-switch form-switch-lg mb-3" >
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="customSwitchsizelg"
                            checked={registerdevice}
                            onChange={(event) => setregisterdevice(event.target.checked)}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="customSwitchsizelg"
                        >
                           <h6> Register Device</h6> 
                        </label>
                    </div>
                </Col>
                                       
                      <Col md={12} style={{display:"inline-block"}}>                      
                    <div style={{display:"inline-block"}}
                        className="form-check form-switch form-switch-lg mb-3" >
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="customSwitchsizelg"
                            checked={registervehicle}
                            onChange={(event) => setregistervehicle(event.target.checked)}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="customSwitchsizelg"
                        >
                           <h6> Register Vehicle</h6> 
                        </label>
                    </div>
                </Col>
                                  
                      <Col md={12} style={{display:"inline-block"}}>
                        
                    <div style={{display:"inline-block"}}
                        className="form-check form-switch form-switch-lg mb-3" >
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="customSwitchsizelg"
                            checked={smtp}
                            onChange={(event) => setsmtp(event.target.checked)}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="customSwitchsizelg"
                        >
                           <h6> Email and SMS Access</h6> 
                        </label>
                    </div>
                </Col>
                                        
                      <Col md={12} style={{display:"inline-block"}}>
                        
                    <div style={{display:"inline-block"}}
                        className="form-check form-switch form-switch-lg mb-3" >
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="customSwitchsizelg"
                            checked={challan}
                            onChange={(event) => setchallan(event.target.checked)}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="customSwitchsizelg"
                        >
                           <h6> Challan</h6> 
                        </label>
                    </div>
                </Col>
                    </CardBody></Card>
                        </Col>

                        <Col md={6} style={{}}> 
                         <Card>
                      <CardBody>  
                        <h5> User/Role Management</h5>

                      <br></br>
                      <Col md={6} style={{display:"inline-block"}}>                       
                    <div style={{display:"inline-block"}}
                        className="form-check form-switch form-switch-lg mb-3" >
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="customSwitchsizelg"
                            checked={usermanagement}
                            onChange={(event) => setusermanagement(event.target.checked)}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="customSwitchsizelg"
                        >
                           <h6> User Management</h6> 
                        </label>
                    </div>                 
                </Col>
                <Col md={6} style={{display:"inline-block"}}>
                        
                        <div style={{display:"inline-block"}}
                            className="form-check form-switch form-switch-lg mb-3" >
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="customSwitchsizelg"
                                checked={adduser}
                                onChange={(event) => setadduser(event.target.checked)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="customSwitchsizelg"
                            >
                               <h6>Add User</h6> 
                            </label>
                        </div>                 
                    </Col>
                <Col md={6} style={{display:"inline-block"}}>
                        
                        <div style={{display:"inline-block"}}
                            className="form-check form-switch form-switch-lg mb-3" >
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="customSwitchsizelg"
                                checked={editdeleteuser}
                                onChange={(event) => seteditdeleteuser(event.target.checked)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="customSwitchsizelg"
                            >
                               <h6> Edit / Delete User</h6> 
                            </label>
                        </div>                 
                    </Col>
                    <Col md={6} style={{display:"inline-block"}}>
                        
                        <div style={{display:"inline-block"}}
                            className="form-check form-switch form-switch-lg mb-3" >
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="customSwitchsizelg"
                                checked={rolemanagement}
                                onChange={(event) => setrolemanagement(event.target.checked)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="customSwitchsizelg"
                            >
                               <h6> Role Management</h6> 
                            </label>
                        </div>                 
                    </Col>
                    <Col md={6} style={{display:"inline-block"}}>
                        
                        <div style={{display:"inline-block"}}
                            className="form-check form-switch form-switch-lg mb-3" >
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="customSwitchsizelg"
                                checked={addrole}
                                onChange={(event) => setaddrole(event.target.checked)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="customSwitchsizelg"
                            >
                               <h6>Add Role</h6> 
                            </label>
                        </div>                 
                    </Col>
                    <Col md={6} style={{display:"inline-block"}}>
                        
                        <div style={{display:"inline-block"}}
                            className="form-check form-switch form-switch-lg mb-3" >
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="customSwitchsizelg"
                                checked={editdeleterole}
                                onChange={(event) => seteditdeleterole(event.target.checked)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="customSwitchsizelg"
                            >
                               <h6>Edit / Delete Role</h6> 
                            </label>
                        </div>                 
                    </Col>
                    <Col md={6} style={{display:"inline-block"}}>
                        
                        <div style={{display:"inline-block"}}
                            className="form-check form-switch form-switch-lg mb-3" >
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="customSwitchsizelg"
                                checked={changepassword}
                                onChange={(event) => setchangepassword(event.target.checked)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="customSwitchsizelg"
                            >
                               <h6>Change Password</h6> 
                            </label>
                        </div>                 
                    </Col>
                </CardBody>
                </Card>
                </Col>
                        </Row>              
                   
                   </Row>
}
<Row>
</Row>
{editdeleteroleaccess &&
                   <Row>


                    <Col  className="col-md-offset-10" sm={12} lg={10}></Col>
                    <Col lg={1} md={1} sm={6}>                 
                   <Button onClick={DeleteRole}style={{float:"right"}} type="button"  color="primary" className="waves-effect waves-light">Delete   </Button>{" "}
                   </Col>
                   <Col lg={1} md={1} sm={6}>                  
                   <Button  onClick={SaveRolePermissions}  type="button" color="primary" className="waves-effect waves-light">Save </Button>{" "}
                   </Col>
                   </Row>
}
                   <div tabIndex={0}>
                   <Modal tabIndex={0}  isOpen={modalIsOpen}>
                   <ModalHeader toggle={toggle} tag="h4">
                    Add New Role
          </ModalHeader>
          <ModalBody>
            <AvForm className="needs-validation"onSubmit={AddNewRole}>
            {alertModal}   
              <Row>

                <Col md={12}>
                  <label for="roleName" className="mt-3">Name</label>
                 <AvField
                    name="roleName"
                    type="text"
                    className="form-control"                  
                    id="roleName"
                    required
                    validate={{
                        required: {value: true, errorMessage: 'Please enter name of the role'},
                        pattern: {value: '^[A-Za-z]+$', errorMessage: 'Role name must be composed only with letters'},
                        minLength: {value: 3, errorMessage: 'Role name must be between 3 and 16 characters'},
                        maxLength: {value: 16, errorMessage: 'Role name must be between 3 and 16 characters'}
                      }}
                  />
                </Col>
                </Row>
                <br></br>
                <Row>
                <Col md={12} >
                    <Col md={10}></Col>
                    <Col md={2} style={{float:"right"}}>
                  <Button size="lg" color="primary" className="waves-effect waves-light"
                   role="Button" id="addRole" >Add</Button>
                    </Col>
                </Col>
             
           
              </Row>
            </AvForm>
          </ModalBody>


                   </Modal>

         

                   </div>
                   {basic ? (
                    <ReactBSAlert
                   success
                   style={bsAlertStyle}
                   title="New user role added!"
                   onConfirm={() => {
                    setAlert(null)
                    setbasic(false)
                  }}
                  confirmBtnBsStyle="info"
                 >                  
                 </ReactBSAlert>

      ) : null}
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(UserRoles);
